import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import './core/vant.js'
import './assets/iconfont/iconfont.css'
import '@/router/interceptor.js'
import commonInstall from '@/common/install'
Vue.use(commonInstall)
import storeInstall from '@/store/install'
Vue.use(storeInstall)

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.config.ignoredElements = ['wx-open-launch-weapp']

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
